import { render, staticRenderFns } from "./ChainTitle.vue?vue&type=template&id=59be592e&scoped=true&"
import script from "./ChainTitle.vue?vue&type=script&lang=ts&"
export * from "./ChainTitle.vue?vue&type=script&lang=ts&"
import style0 from "./ChainTitle.vue?vue&type=style&index=0&id=59be592e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59be592e",
  null
  
)

export default component.exports